module.exports = __webpack_public_path__ + "static/media/quotes-step-icon.afcd52a6.svg";